"use strict";

var _regeneratorRuntime = require("/var/www/attheme-editor.snejugal.ru/node_modules/@babel/runtime/regenerator");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var _a;

Object.defineProperty(exports, "__esModule", {
  value: true
});

var api_1 = require("./api");

var makeRequest = function makeRequest(data) {
  return __awaiter(void 0, void 0, void 0,
  /*#__PURE__*/
  _regeneratorRuntime.mark(function _callee() {
    var body, response, json;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            body = JSON.stringify(data);
            _context.next = 3;
            return fetch(api_1.API_URL, {
              method: "post",
              body: body
            });

          case 3:
            response = _context.sent;
            _context.next = 6;
            return response.json();

          case 6:
            json = _context.sent;

            if (!response.ok) {
              _context.next = 9;
              break;
            }

            return _context.abrupt("return", json);

          case 9:
            throw new Error(json.error);

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

_a = api_1["default"](makeRequest), exports.createOpenInEditorLink = _a.createOpenInEditorLink, exports.uploadTheme = _a.uploadTheme, exports.downloadTheme = _a.downloadTheme;